class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length === 0;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    // Check if we should open the details (if it is manually set to open or it's the last child)
    const isLastChild = this.isLastChild();
    const hasOpenAttribute = this.detailsContainer.hasAttribute('open');

    if (!theme.config.mqlSmall || this.summaryIsEmpty || isLastChild || hasOpenAttribute) {
      this.open(); // Ensure it stays open if it has the `open` attribute or is last child
    } else {
      if (this.dataset.open === undefined) {
        this.detailsContainer.removeAttribute('open');
      }
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    details.hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    if (theme.config.mqlSmall && !this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute('open');
    }
  }

  // Method to check if this element is the last child
  isLastChild() {
    const parent = this.closest('.footer-block');
    if (parent) {
      const lastChild = parent.querySelector('.footer-block__details-content:last-child');
      return lastChild === this;
    }
    return false;
  }
}

customElements.define('footer-accordion', FooterAccordion);
